import React, { useState, useEffect } from "react";
import { Row, Col, Input, Form } from "antd";
import { IonLabel } from "@ionic/react";

import { useTranslation } from "react-i18next";
import log from "../../utils/log";

const Street = ({ state = {}, ...props }) => {
  const { data, form, rules, onChange } = state;
  const { t, i18n } = useTranslation();
  
  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ "address.street": data });
  }, [data]);

  return (
    <Row {...props}>
      <Col span={6}>
        <IonLabel style={{ fontSize: "1rem" }}>{t("newVendor.street")}&nbsp;</IonLabel>
      </Col>
      <Col span={18}>
        <Form form={form} layout="vertical" style={{ width: "100%" }}>
          <Form.Item name="address.street" rules={rules}>
            <Input
              value={data}
              size="large"
              style={{ width: "100%" }}
              onChange={(e) => {
                onChange({ address: { street: e?.target?.value } });
              }}
            />
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default Street;
